// Thu Mar 27 06:04:36 GMT 2025

import * as models from "../crm-web-api-models"

export enum CreditCardProp {
	ApprovedByCustomer = 'approvedByCustomer',
	BillingCity = 'billingCity',
	BillingCountry = 'billingCountry',
	BillingState = 'billingState',
	BillingStreet = 'billingStreet',
	BillingZipCode = 'billingZipCode',
	CreationTime = 'creationTime',
	CreditCardType = 'creditCardType',
	CustomerId = 'customer.id',
	CustomerPersonName = 'customer.person.name',
	Cvv2 = 'cvv2',
	DepositTotalsTotalDoneDepositsAmount = 'depositTotals.totalDoneDepositsAmount',
	DepositTotalsTotalPendingDepositsAmount = 'depositTotals.totalPendingDepositsAmount',
	Description = 'description',
	ExpirationDate = 'expirationDate',
	HolderName = 'holderName',
	Id = 'id',
	ModificationTime = 'modificationTime',
	ModifiedBy = 'modifiedBy',
	Number = 'number',
	NumberHash = 'numberHash',
	ProfitRefundAllowed = 'profitRefundAllowed',
	SafechargeToken = 'safechargeToken',
	Status = 'status',
	TokenCreationDate = 'tokenCreationDate',
	TotalWithdrawalsBaseCurrencyAmount = 'totalWithdrawalsBaseCurrencyAmount'
}

export type CreditCardPropApprovedByCustomer = {
	[CreditCardProp.ApprovedByCustomer] : boolean | null
}
export type CreditCardPropBillingCity = {
	[CreditCardProp.BillingCity] : string | null
}
export type CreditCardPropBillingCountry = {
	[CreditCardProp.BillingCountry] : 'NA' | 'AFGHANISTAN' | 'ÅLAND_ISLANDS' | 'ALBANIA' | 'ALGERIA' | 'AMERICAN_SAMOA' | 'ANDORRA' | 'ANGOLA' | 'ANGUILLA' | 'ANTARCTICA' | 'ANTIGUA_AND_BARBUDA' | 'ARGENTINA' | 'ARMENIA' | 'ARUBA' | 'AUSTRALIA' | 'AUSTRIA' | 'AZERBAIJAN' | 'BAHAMAS' | 'BAHRAIN' | 'BANGLADESH' | 'BARBADOS' | 'BELARUS' | 'BELGIUM' | 'BELIZE' | 'BENIN' | 'BERMUDA' | 'BHUTAN' | 'BOLIVIA' | 'BONAIRE_SINT_EUSTATIUS_AND_SABA' | 'BOSNIA_AND_HERZEGOVINA' | 'BOTSWANA' | 'BOUVET_ISLAND' | 'BRAZIL' | 'BRITISH_INDIAN_OCEAN_TERRITORY' | 'BRUNEI_DARUSSALAM' | 'BULGARIA' | 'BURKINA_FASO' | 'BURUNDI' | 'CAMBODIA' | 'CAMEROON' | 'CANADA' | 'CAPE_VERDE' | 'CAYMAN_ISLANDS' | 'CENTRAL_AFRICAN_REPUBLIC' | 'CHAD' | 'CHILE' | 'CHINA' | 'CHRISTMAS_ISLAND' | 'COCOS_ISLANDS' | 'COLOMBIA' | 'COMOROS' | 'CONGO' | 'CONGO_THE_DEMOCRATIC_REPUBLIC_OF_THE' | 'COOK_ISLANDS' | 'COSTA_RICA' | 'CROATIA' | 'CUBA' | 'CURAÇAO' | 'CYPRUS' | 'CZECH_REPUBLIC' | 'CÔTE_DIVOIRE' | 'DENMARK' | 'DJIBOUTI' | 'DOMINICA' | 'DOMINICAN_REPUBLIC' | 'EAST_TIMOR' | 'ECUADOR' | 'EGYPT' | 'EL_SALVADOR' | 'EQUATORIAL_GUINEA' | 'ERITREA' | 'ESTONIA' | 'ETHIOPIA' | 'FALKLAND_ISLANDS' | 'FAROE_ISLANDS' | 'FIJI' | 'FINLAND' | 'FRANCE' | 'FRENCH_GUIANA' | 'FRENCH_POLYNESIA' | 'FRENCH_SOUTHERN_TERRITORIES' | 'GABON' | 'GAMBIA' | 'Georgia' | 'GERMANY' | 'GHANA' | 'GIBRALTAR' | 'GREECE' | 'GREENLAND' | 'GRENADA' | 'GUADELOUPE' | 'GUAM' | 'GUATEMALA' | 'GUERNSEY' | 'GUINEA' | 'GUINEA_BISSAU' | 'GUYANA' | 'HAITI' | 'HEARD_ISLAND_AND_MCDONALD_ISLANDS' | 'HONDURAS' | 'HONG_KONG' | 'Hungary' | 'ICELAND' | 'INDIA' | 'INDONESIA' | 'IRAN' | 'IRAQ' | 'IRELAND' | 'ISLE_OF_MAN' | 'ISRAEL' | 'ITALY' | 'JAMAICA' | 'JAPAN' | 'JERSEY' | 'JORDAN' | 'KAZAKHSTAN' | 'KENYA' | 'KIRIBATI' | 'KOSOVO' | 'KOREA_DEMOCRATIC_PEOPLE_REPUBLIC_OF' | 'KOREA_REPUBLIC_OF' | 'KUWAIT' | 'KYRGYZSTAN' | 'LAO_PEOPLE_DEMOCRATIC_REPUBLIC' | 'LATVIA' | 'LEBANON' | 'LESOTHO' | 'LIBERIA' | 'LIBYAN' | 'LIECHTENSTEIN' | 'LITHUANIA' | 'LUXEMBOURG' | 'MACAO' | 'MADAGASCAR' | 'MALAWI' | 'MALAYSIA' | 'MALDIVES' | 'MALI' | 'MALTA' | 'MARSHALL_ISLANDS' | 'MARTINIQUE' | 'MAURITANIA' | 'MAURITIUS' | 'MAYOTTE' | 'MEXICO' | 'MICRONESIA' | 'MOLDOVA_REPUBLIC_OF' | 'MONACO' | 'MONGOLIA' | 'MONTENEGRO' | 'MONTSERRAT' | 'MOROCCO' | 'MOZAMBIQUE' | 'MYANMAR' | 'NAMIBIA' | 'NAURU' | 'NEPAL' | 'NETHERLANDS' | 'NETHERLANDS_ANTILLES' | 'NEW_CALEDONIA' | 'NEW_ZEALAND' | 'NICARAGUA' | 'NIGER' | 'NIGERIA' | 'NIUE' | 'NORFOLK_ISLAND' | 'NORTHERN_MARIANA_ISLANDS' | 'NORWAY' | 'OMAN' | 'PAKISTAN' | 'PALAU' | 'PALESTINIAN_TERRITORY_OCCUPIED' | 'PANAMA' | 'PAPUA_NEW_GUINEA' | 'PARAGUAY' | 'PERU' | 'PHILIPPINES' | 'PITCAIRN' | 'POLAND' | 'PORTUGAL' | 'PUERTO_RICO' | 'QATAR' | 'ROMANIA' | 'RUSSIAN_FEDERATION' | 'RWANDA' | 'RÉUNION' | 'SAINT_BARTHÉLEMY_BL' | 'SAINT_HELENA' | 'SAINT_KITTS_AND_NEVIS' | 'SAINT_LUCIA' | 'SAINT_MARTIN_FRENCH_PART' | 'SAINT_PIERRE_AND_MIQUELON' | 'SAINT_VINCENT_AND_THE_GRENADINES' | 'SAMOA' | 'SAN_MARINO' | 'SAO_TOME_AND_PRINCIPE' | 'SAUDI_ARABIA' | 'SENEGAL' | 'SERBIA' | 'SEYCHELLES' | 'SIERRA_LEONE' | 'SINGAPORE' | 'SINT_MAARTEN_DUTCH_PART' | 'SLOVAKIA' | 'SLOVENIA' | 'SOLOMON_ISLANDS' | 'SOMALIA' | 'SOUTH_AFRICA' | 'SOUTH_GEORGIA_AND_THE_SOUTH_SANDWICH_ISLANDS' | 'SOUTH_SUDAN' | 'SPAIN' | 'SRI_LANKA' | 'SUDAN' | 'SURINAME' | 'SVALBARD_AND_JAN_MAYEN' | 'SWAZILAND' | 'SWEDEN' | 'SWITZERLAND' | 'SYRIAN_ARAB_REPUBLIC' | 'TAIWAN' | 'TAJIKISTAN' | 'THAILAND' | 'THE_FORMER_YUGOSLAV_REPUBLIC_OF_MACEDONIA' | 'TOGO' | 'TOKELAU' | 'TONGA' | 'TRINIDAD_AND_TOBAGO' | 'TUNISIA' | 'TURKEY' | 'TURKMENISTAN' | 'TURKS_AND_CAICOS_ISLANDS' | 'TUVALU' | 'UGANDA' | 'UKRAINE' | 'UNITED_ARAB_EMIRATES' | 'UNITED_KINGDOM' | 'UNITED_REPUBLIC_OF_TANZANIA' | 'UNITED_STATES_MINOR_OUTLYING_ISLANDS' | 'URUGUAY' | 'USA' | 'UZBEKISTAN' | 'VANUATU' | 'VATICAN_CITY_STATE' | 'VENEZUELA' | 'VIET_NAM' | 'VIRGIN_ISLANDS_GB' | 'VIRGIN_ISLANDS_USA' | 'WALLIS_AND_FUTUNA' | 'WESTERN_SAHARA' | 'YEMEN' | 'ZAMBIA' | 'ZIMBABWE' | null
}
export type CreditCardPropBillingState = {
	[CreditCardProp.BillingState] : string | null
}
export type CreditCardPropBillingStreet = {
	[CreditCardProp.BillingStreet] : string | null
}
export type CreditCardPropBillingZipCode = {
	[CreditCardProp.BillingZipCode] : string | null
}
export type CreditCardPropCreationTime = {
	[CreditCardProp.CreationTime] : number | null
}
export type CreditCardPropCreditCardType = {
	[CreditCardProp.CreditCardType] : 'UNKNOWN' | 'MASTER_CARD' | 'VISA' | 'DINERS' | 'AMERICAN_EXPRESS' | 'JCB' | 'DISCOVER' | 'LASERCARD' | 'MAESTRO' | 'SOLO' | 'SWITCH' | 'ENTROPAY' | 'DANKORT_VISA' | null
}
export type CreditCardPropCustomerId = {
	[CreditCardProp.CustomerId] : number | null
}
export type CreditCardPropCustomerPersonName = {
	[CreditCardProp.CustomerPersonName] : string | null
}
export type CreditCardPropCvv2 = {
	[CreditCardProp.Cvv2] : string | null
}
export type CreditCardPropDepositTotalsTotalDoneDepositsAmount = {
	[CreditCardProp.DepositTotalsTotalDoneDepositsAmount] : number | null
}
export type CreditCardPropDepositTotalsTotalPendingDepositsAmount = {
	[CreditCardProp.DepositTotalsTotalPendingDepositsAmount] : number | null
}
export type CreditCardPropDescription = {
	[CreditCardProp.Description] : string | null
}
export type CreditCardPropExpirationDate = {
	[CreditCardProp.ExpirationDate] : string | null
}
export type CreditCardPropHolderName = {
	[CreditCardProp.HolderName] : string | null
}
export type CreditCardPropId = {
	[CreditCardProp.Id] : number
}
export type CreditCardPropModificationTime = {
	[CreditCardProp.ModificationTime] : number | null
}
export type CreditCardPropModifiedBy = {
	[CreditCardProp.ModifiedBy] : models.UserDto
}
export type CreditCardPropNumber = {
	[CreditCardProp.Number] : string | null
}
export type CreditCardPropNumberHash = {
	[CreditCardProp.NumberHash] : string | null
}
export type CreditCardPropProfitRefundAllowed = {
	[CreditCardProp.ProfitRefundAllowed] : boolean | null
}
export type CreditCardPropSafechargeToken = {
	[CreditCardProp.SafechargeToken] : string | null
}
export type CreditCardPropStatus = {
	[CreditCardProp.Status] : 'PENDING' | 'APPROVED' | 'REJECTED' | 'BLACK_LISTED' | 'REVOKE_PENDING' | null
}
export type CreditCardPropTokenCreationDate = {
	[CreditCardProp.TokenCreationDate] : number | null
}
export type CreditCardPropTotalWithdrawalsBaseCurrencyAmount = {
	[CreditCardProp.TotalWithdrawalsBaseCurrencyAmount] : number | null
}


export type CreditCard = 
	CreditCardPropApprovedByCustomer & 
	CreditCardPropBillingCity & 
	CreditCardPropBillingCountry & 
	CreditCardPropBillingState & 
	CreditCardPropBillingStreet & 
	CreditCardPropBillingZipCode & 
	CreditCardPropCreationTime & 
	CreditCardPropCreditCardType & 
	CreditCardPropCustomerId & 
	CreditCardPropCustomerPersonName & 
	CreditCardPropCvv2 & 
	CreditCardPropDepositTotalsTotalDoneDepositsAmount & 
	CreditCardPropDepositTotalsTotalPendingDepositsAmount & 
	CreditCardPropDescription & 
	CreditCardPropExpirationDate & 
	CreditCardPropHolderName & 
	CreditCardPropId & 
	CreditCardPropModificationTime & 
	CreditCardPropModifiedBy & 
	CreditCardPropNumber & 
	CreditCardPropNumberHash & 
	CreditCardPropProfitRefundAllowed & 
	CreditCardPropSafechargeToken & 
	CreditCardPropStatus & 
	CreditCardPropTokenCreationDate & 
	CreditCardPropTotalWithdrawalsBaseCurrencyAmount

export const CREDIT_CARD_PROPERTY_NAMES = Object.freeze([CreditCardProp.ApprovedByCustomer, CreditCardProp.BillingCity, CreditCardProp.BillingCountry, CreditCardProp.BillingState, CreditCardProp.BillingStreet, CreditCardProp.BillingZipCode, CreditCardProp.CreationTime, CreditCardProp.CreditCardType, CreditCardProp.CustomerId, CreditCardProp.CustomerPersonName, CreditCardProp.Cvv2, CreditCardProp.DepositTotalsTotalDoneDepositsAmount, CreditCardProp.DepositTotalsTotalPendingDepositsAmount, CreditCardProp.Description, CreditCardProp.ExpirationDate, CreditCardProp.HolderName, CreditCardProp.Id, CreditCardProp.ModificationTime, CreditCardProp.ModifiedBy, CreditCardProp.Number, CreditCardProp.NumberHash, CreditCardProp.ProfitRefundAllowed, CreditCardProp.SafechargeToken, CreditCardProp.Status, CreditCardProp.TokenCreationDate, CreditCardProp.TotalWithdrawalsBaseCurrencyAmount])

export type CreditCardCreate = 
	CreditCardPropCustomerId & 
	CreditCardPropNumber & 
	CreditCardPropCreditCardType & 
	CreditCardPropCvv2 & 
	CreditCardPropExpirationDate & 
	CreditCardPropHolderName & 
	CreditCardPropBillingCountry & 
	CreditCardPropBillingCity & 
	CreditCardPropBillingStreet & 
	CreditCardPropBillingState & 
	CreditCardPropBillingZipCode & 
	CreditCardPropDescription

export const CREDIT_CARD_CREATE_PROPERTY_NAMES = Object.freeze([CreditCardProp.CustomerId, CreditCardProp.Number, CreditCardProp.CreditCardType, CreditCardProp.Cvv2, CreditCardProp.ExpirationDate, CreditCardProp.HolderName, CreditCardProp.BillingCountry, CreditCardProp.BillingCity, CreditCardProp.BillingStreet, CreditCardProp.BillingState, CreditCardProp.BillingZipCode, CreditCardProp.Description])

export type CreditCardTab = 
	CreditCardPropId & 
	CreditCardPropNumber & 
	CreditCardPropCustomerPersonName

export const CREDIT_CARD_TAB_PROPERTY_NAMES = Object.freeze([CreditCardProp.Id, CreditCardProp.Number, CreditCardProp.CustomerPersonName])

export type CreditCardHistoryTab = 
	CreditCardPropId & 
	CreditCardPropNumber & 
	CreditCardPropCustomerPersonName

export const CREDIT_CARD_HISTORY_TAB_PROPERTY_NAMES = Object.freeze([CreditCardProp.Id, CreditCardProp.Number, CreditCardProp.CustomerPersonName])

export type CreditCardHeader = 
	CreditCardPropId & 
	CreditCardPropCustomerPersonName & 
	CreditCardPropCustomerId & 
	CreditCardPropNumberHash

export const CREDIT_CARD_HEADER_PROPERTY_NAMES = Object.freeze([CreditCardProp.Id, CreditCardProp.CustomerPersonName, CreditCardProp.CustomerId, CreditCardProp.NumberHash])

export type CreditCardInformation = 
	CreditCardPropId & 
	CreditCardPropCreationTime & 
	CreditCardPropModificationTime & 
	CreditCardPropModifiedBy & 
	CreditCardPropCustomerId & 
	CreditCardPropCustomerPersonName & 
	CreditCardPropNumber & 
	CreditCardPropCreditCardType & 
	CreditCardPropSafechargeToken & 
	CreditCardPropTokenCreationDate & 
	CreditCardPropStatus & 
	CreditCardPropApprovedByCustomer & 
	CreditCardPropHolderName & 
	CreditCardPropBillingCountry & 
	CreditCardPropBillingCity & 
	CreditCardPropBillingStreet & 
	CreditCardPropBillingState & 
	CreditCardPropBillingZipCode & 
	CreditCardPropExpirationDate & 
	CreditCardPropTotalWithdrawalsBaseCurrencyAmount & 
	CreditCardPropDepositTotalsTotalDoneDepositsAmount & 
	CreditCardPropDepositTotalsTotalPendingDepositsAmount & 
	CreditCardPropProfitRefundAllowed & 
	CreditCardPropDescription

export const CREDIT_CARD_INFORMATION_PROPERTY_NAMES = Object.freeze([CreditCardProp.Id, CreditCardProp.CreationTime, CreditCardProp.ModificationTime, CreditCardProp.ModifiedBy, CreditCardProp.CustomerId, CreditCardProp.CustomerPersonName, CreditCardProp.Number, CreditCardProp.CreditCardType, CreditCardProp.SafechargeToken, CreditCardProp.TokenCreationDate, CreditCardProp.Status, CreditCardProp.ApprovedByCustomer, CreditCardProp.HolderName, CreditCardProp.BillingCountry, CreditCardProp.BillingCity, CreditCardProp.BillingStreet, CreditCardProp.BillingState, CreditCardProp.BillingZipCode, CreditCardProp.ExpirationDate, CreditCardProp.TotalWithdrawalsBaseCurrencyAmount, CreditCardProp.DepositTotalsTotalDoneDepositsAmount, CreditCardProp.DepositTotalsTotalPendingDepositsAmount, CreditCardProp.ProfitRefundAllowed, CreditCardProp.Description])
